// These adapters follow the overview/response contracts in the root Swagger file.
export const getResultData = (response) => {
  if (!response?.data || response.data.success === false) {
    throw new Error(response?.data?.message || "The survey request did not complete.");
  }
  return response.data.data;
};

export const mergeSurveyOverview = (survey, overview = {}) => {
  const summary = overview.summary || {};
  const status = overview.survey_status || {};
  return {
    ...survey,
    ...overview.survey,
    ...(summary.total_responses != null && { responses: summary.total_responses }),
    ...(summary.completion_rate != null && { completion_rate: summary.completion_rate }),
    ...(summary.avg_completion_time != null && { avg_completion_time: summary.avg_completion_time }),
    ...(summary.drop_off_rate != null && { drop_off_rate: summary.drop_off_rate }),
    ...(status.target_responses != null && { target_responses: status.target_responses }),
    ...(status.responses_received != null && { responses: status.responses_received }),
    ...(status.status != null && { status: status.status }),
    ...(status.start_date && { start_date: status.start_date }),
    ...(status.end_date && { end_date: status.end_date }),
  };
};

export const getDeviceBreakdown = (overview = {}) => {
  const breakdown = overview.key_metrics?.device_breakdown;
  const devices = Array.isArray(breakdown?.devices) ? breakdown.devices : [];
  const total = breakdown?.total_sessions == null ? null : Number(breakdown.total_sessions) || 0;
  return {
    total,
    devices: ["Desktop", "Mobile", "Tablet"].map((name) => {
      const device = devices.find((item) => String(item.device_type).toLowerCase() === name.toLowerCase());
      const count = breakdown ? Number(device?.sessions) || 0 : null;
      return { name, count, percent: breakdown ? Number(device?.percentage ?? (total ? count / total * 100 : 0)) : null };
    }),
  };
};

export const buildResponseParams = ({ page = 1, search = "", status = "All", device = "All", date = "Last 7 Days" } = {}) => {
  const params = { page, limit: 10 };
  if (search.trim()) params.search = search.trim();
  if (status !== "All") params.status = status.toLowerCase();
  if (device !== "All") params.device = device;
  const range = { "Last 7 Days": "7", "Last 30 Days": "30", "Last 90 Days": "90" }[date];
  if (range) params.date_range = range;
  return params;
};

export const parseResponsePage = (data = {}) => {
  const pagination = data.pagination || {};
  const rows = Array.isArray(data.responses) ? data.responses : [];
  const total = Number(pagination.total) || 0;
  const limit = Number(pagination.limit) || 10;
  return {
    rows,
    total,
    page: Number(pagination.page) || 1,
    limit,
    pages: Math.max(1, Number(pagination.total_pages) || Math.ceil(total / limit)),
  };
};

export const responseIdForDeletion = (row) => {
  // participant_id identifies the participant, not an individual answer record.
  const id = row?.response_id ?? row?.survey_response_id;
  return /^[1-9]\d*$/.test(String(id ?? "")) ? id : null;
};

export const parseSubmissionDate = (value) => {
  if (!value) return null;
  // The documented timestamp uses "15 Oct 2026, 10:30 am".
  const match = String(value).match(/^(\d{1,2}) ([A-Za-z]{3}) (\d{4}),? (\d{1,2}):(\d{2})\s*(am|pm)$/i);
  let date;
  if (match) {
    const month = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"].indexOf(match[2].toLowerCase());
    if (month < 0) return null;
    const hour = Number(match[4]) % 12 + (match[6].toLowerCase() === "pm" ? 12 : 0);
    date = new Date(Number(match[3]), month, Number(match[1]), hour, Number(match[5]));
  } else {
    date = new Date(value);
  }
  return Number.isNaN(date.getTime()) ? null : date;
};
